import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box } from '@mui/material';
import React from 'react';
import { TimelineEventStatus } from '../../slices/marketplace/timeline/models/enums/timeline-event-status.enum';
import './TimelineDependencyChips.scss';

interface TimelineDependencyChipsProps {
    index: number;
    eventIndex: number;
    eventName: string;
    offsetDays: number;
    isRemovable: boolean;
    onRemoveButtonClick?(): void;
}

const TimelineDependencyChips = (props: TimelineDependencyChipsProps) => {
    const { index, eventIndex, eventName, offsetDays, isRemovable } = props;

    return (
        <div key={index} className="timeline-dependency-chips">
            <span
                className="text-bold"
                style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                }}>
                {`${eventIndex + 1}.`}
                <span className="event-name-label" title={eventName}>
                    {eventName || 'Unknown'}
                </span>
            </span>
            <span className="offset-lable">
                <span>{` ${offsetDays} days`}</span>
                {isRemovable ? (
                    <FontAwesomeIcon
                        title="Remove dependency"
                        icon={faTimes}
                        className="cursor-pointer"
                        style={{
                            marginLeft: '6px',
                        }}
                        size="lg"
                        onClick={() => {
                            props.onRemoveButtonClick();
                        }}
                    />
                ) : (
                    []
                )}
            </span>
        </div>
    );
};

export default TimelineDependencyChips;
